import { IsNotEmpty, MaxLength, Validate, IsDefined } from 'class-validator';
import * as uuid from 'uuid';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ContactsValidation } from 'src/core/customValidator/contactsValidator';
import { SupplierDynamicPropertyValidator } from 'src/core/customValidator/supplierDynamicPropertyValidator';

export class SupplierDataService extends DataService<typeof Model.Products.Logic.ViewModels.SupplierItem, Model.Products.Logic.ViewModels.SupplierItem, SupplierItem> {
	protected map(entity: Model.Products.Logic.ViewModels.SupplierItem): SupplierItem {
		return new SupplierItemModel(entity);
	}

	static make(context?: any): SupplierDataService {
		return new SupplierDataService(context, ctx => ctx.Suppliers);
	}

	add(type: string, managedById: number): Promise<SupplierItem> {
		const entity = new Model.Products.Logic.ViewModels.SupplierItem();
		entity.supplierNumber = 'SupplierNumber';
		entity.type = type == 'General' ? 0 : 1;
		entity.documentsLibraryId = uuid.v4();
		entity.defaultMargin = '0.25';
		entity.managedById = managedById;

		const dynamicProperties = (<any>entity).dynamicProperties;
		dynamicProperties['contacts'] = [];
		dynamicProperties['language'] = null;

		return this.create(() => entity);
	}
}

export class SupplierItemModel extends EntityModel<Model.Products.Logic.ViewModels.SupplierItem, SupplierItem> implements SupplierItem {
	@property<SupplierItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<SupplierItemModel>(o => o.entity.supplierNumber, (o, value) => o.entity.supplierNumber = value)
	public supplierNumber: string;

	@property<SupplierItemModel>(o => o.entity.title, (o, value) => o.entity.title = value)
	@IsDefined({
		message: 'title by should not be empty'
	})
	@MaxLength(128)
	public title: string;

	@property<SupplierItemModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(ContactsValidation)
	@Validate(SupplierDynamicPropertyValidator)
	public dynamicProperties: {};

	@property<SupplierItemModel>(o => o.entity.defaultCurrencyId, (o, value) => o.entity.defaultCurrencyId = value)
	@IsDefined(({
		message: 'default currency should not be empty'
	}))
	public defaultCurrencyId: number;

	@property<SupplierItemModel>(o => o.entity.managedById, (o, value) => o.entity.managedById = value)
	@IsDefined({
		message: 'managed by should not be empty'
	})
	public managedById: number;

	@property<SupplierItemModel>(o => o.entity.defaultMargin, (o, value) => o.entity.defaultMargin = value)
	@IsDefined({
		message: 'default margin should not be empty'
	})
	public defaultMargin: number;

	@property<SupplierItemModel>(o => o.entity.documentsLibraryId, (o, value) => o.entity.documentsLibraryId = value)
	public documentsLibraryId: string;

	@property<SupplierItemModel>(o => o.entity.logo, (o, value) => o.entity.logo = value)
	public logo: Uint8Array;

	constructor(entity: Model.Products.Logic.ViewModels.SupplierItem) {
		super(entity);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/form/supplier-form.data.ts